import { render, staticRenderFns } from "./MainNotify.vue?vue&type=template&id=73f65694&scoped=true"
import script from "./MainNotify.vue?vue&type=script&lang=js"
export * from "./MainNotify.vue?vue&type=script&lang=js"
import style0 from "./MainNotify.vue?vue&type=style&index=0&id=73f65694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f65694",
  null
  
)

export default component.exports